<template>
    <div>        
        <div class="main-content" :style="fontFamilyStyle">
            <div class="wb-wrap">
                <div class="wb-sticky-header">
                    <div class="wb-header-titles">
                      <div class="wb-title">{{ this.wbtitle }}</div>
                      <div v-if="showRecipient" class="wb-recipient">For {{ this.wbrecipient }}</div>
                    </div>
                    <div class="wb-actions">
                        <button class="wb-action-btn" @click="editMode" title="Back to edit mode">
                          <i class="bx bx-edit"></i><span>Edit</span>
                        </button>
                    </div>
                </div>

                <div id="bg" class="cards" :style="{ 'background-image': backgroundImage }">
                    <div v-for="wish in wishes" :key="wish.id" class="wishcard">

                      <!-- Media: YouTube or image -->
                      <div v-if="wish.wish_image_url" class="wish-media">
                        <div v-if="isYouTubeUrl(wish.wish_image_url)" class="wish-yt" @click="toggleYT(wish)">
                          <template v-if="!wish._ytPlaying">
                            <img
                              :src="'https://img.youtube.com/vi/' + getYouTubeId(wish.wish_image_url) + '/hqdefault.jpg'"
                              class="wish-yt-thumb"
                              alt="video"
                              @error="e => e.target.style.display='none'"
                            />
                            <div class="wish-yt-play"><i class="bx bx-play-circle"></i></div>
                          </template>
                          <iframe v-else class="wish-yt-frame" :src="wish.wish_image_url + '?autoplay=1'"
                            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                        </div>
                        <img v-else class="wish-img" :src="wish.wish_image_url" alt="" loading="lazy"
                          :style="naturalSize(wish)" @load="onWishImageLoad($event, wish)" />
                      </div>

                      <div class="wish-body">
                        <p class="wish-message">{{ wish.wisher_message }}</p>
                      </div>

                      <div class="wish-footer">
                        <div class="wish-avatar" :style="{ background: nameColor(wish.wisher_name) }">
                          {{ initials(wish.wisher_name) }}
                        </div>
                        <div class="wish-meta">
                          <span class="wish-name">{{ wish.wisher_name }}</span>
                          <span class="wish-date">{{ formatWishDate(wish.wish_message_date) }}</span>
                        </div>
                      </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script>
// import axios from 'axios';
import confetti from 'canvas-confetti'; 
import { recipientAddsInfo } from '../utils/pricing'
import { toast } from 'bulma-toast';
import axios from '../axiosConfig';
import ShareButton from "@/components/ShareButton.vue"; // Adjust the path based on your project structure



export default {
    components: {
        ShareButton,
    },
    name: 'Present',
    data () {
        return {
images:[
        { thumbnailUrl: require('@/assets/images/angel-4704518_1280_thumb.png'), original: () => import('@/assets/images/angel-4704518_1280.png') },
        { thumbnailUrl: require('@/assets/images/bee-7666216_1280_thumb.jpg'), original: () => import('@/assets/images/bee-7666216_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/boho-style-7314646_1280_thumb.png'), original: () => import('@/assets/images/boho-style-7314646_1280.png') },
        { thumbnailUrl: require('@/assets/images/chess-8348280_1280_thumb.jpg'), original: () => import('@/assets/images/chess-8348280_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/christmas-trees-8416168_1280_thumb.jpg'), original: () => import('@/assets/images/christmas-trees-8416168_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/cookies-8416230_1280_thumb.jpg'), original: () => import('@/assets/images/cookies-8416230_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/deer-8157052_1280_thumb.png'), original: () => import('@/assets/images/deer-8157052_1280.png') },
        { thumbnailUrl: require('@/assets/images/doodle-7898618_1280_thumb.jpg'), original: () => import('@/assets/images/doodle-7898618_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/floral-7887374_1280_thumb.jpg'), original: () => import('@/assets/images/floral-7887374_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/flowers-6924088_1280_thumb.png'), original: () => import('@/assets/images/flowers-6924088_1280.png') },
        { thumbnailUrl: require('@/assets/images/flowers-7910753_1280_thumb.png'), original: () => import('@/assets/images/flowers-7910753_1280.png') },
        { thumbnailUrl: require('@/assets/images/flowers-7911617_1280_thumb.jpg'), original: () => import('@/assets/images/flowers-7911617_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/flowers-8013886_1280_thumb.png'), original: () => import('@/assets/images/flowers-8013886_1280.png') },
        { thumbnailUrl: require('@/assets/images/flowers-8175044_1280_thumb.png'), original: () => import('@/assets/images/flowers-8175044_1280.png') },
        { thumbnailUrl: require('@/assets/images/flowers-8219261_1280_thumb.png'), original: () => import('@/assets/images/flowers-8219261_1280.png') },
        { thumbnailUrl: require('@/assets/images/hedgehog-7922370_1280_thumb.jpg'), original: () => import('@/assets/images/hedgehog-7922370_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/hut-6968718_1280_thumb.png'), original: () => import('@/assets/images/hut-6968718_1280.png') },
        { thumbnailUrl: require('@/assets/images/ice-cream-8081692_1280_thumb.png'), original: () => import('@/assets/images/ice-cream-8081692_1280.png') },
        { thumbnailUrl: require('@/assets/images/island-7983688_1280_thumb.jpg'), original: () => import('@/assets/images/island-7983688_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/landscape-7704393_1280_thumb.jpg'), original: () => import('@/assets/images/landscape-7704393_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/leaves-8184621_1280_thumb.png'), original: () => import('@/assets/images/leaves-8184621_1280.png') },
        { thumbnailUrl: require('@/assets/images/living-room-7939062_1280_thumb.png'), original: () => import('@/assets/images/living-room-7939062_1280.png') },
        { thumbnailUrl: require('@/assets/images/ornament-7923631_1280_thumb.png'), original: () => import('@/assets/images/ornament-7923631_1280.png') },
        { thumbnailUrl: require('@/assets/images/plants-7933494_1280_thumb.jpg'), original: () => import('@/assets/images/plants-7933494_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/plants-8264654_1280_thumb.jpg'), original: () => import('@/assets/images/plants-8264654_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/plastic-waste-7617451_1280_thumb.jpg'), original: () => import('@/assets/images/plastic-waste-7617451_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/sun-7522095_1280_thumb.jpg'), original: () => import('@/assets/images/sun-7522095_1280.jpg') },
        { thumbnailUrl: require('@/assets/images/tea-time-8100595_1280_thumb.jpg'), original: () => import('@/assets/images/tea-time-8100595_1280.jpg') }
        // { thumbnailUrl: require('@/assets/images/lighthouse-8184255_1280_thumb.jpg'), original: () => import('@/assets/images/lighthouse-8184255_1280.jpg') },
        // { thumbnailUrl: require('@/assets/images/night-7942715_1280_thumb.jpg'), original: () => import('@/assets/images/night-7942715_1280.jpg') },
        // { thumbnailUrl: require('@/assets/images/panda-7897774_1280_thumb.jpg'), original: () => import('@/assets/images/panda-7897774_1280.jpg') },
        // { thumbnailUrl: require('@/assets/images/pattern-8189525_1280_thumb.jpg'), original: () => import('@/assets/images/pattern-8189525_1280.jpg') },
        // { thumbnailUrl: require('@/assets/images/planet-7942329_1280_thumb.jpg'), original: () => import('@/assets/images/planet-7942329_1280.jpg') },
        // { thumbnailUrl: require('@/assets/images/rose-8240077_1280_thumb.jpg'), original: () => import('@/assets/images/rose-8240077_1280.jpg') },
      ],
            // { id: 27, url: 'https://cdn.pixabay.com/photo/2017/10/25/08/25/cupcakes-2887270_1280.jpg'},
        // ],
                

            // Mirrors Wishboard.vue: only real, loaded webfonts, each with a
            // Unicode fallback stack so Tamil/Thai/Devanagari wishes render.
            fonts: [
                { id: 1, name: 'Sofia',      stack: "'Sofia', 'Noto Sans Tamil', 'Noto Sans Thai', 'Noto Sans Devanagari', 'Kailasa', 'Latha', sans-serif" },
                { id: 2, name: 'Raleway',    stack: "'Raleway', 'Noto Sans Tamil', 'Noto Sans Thai', 'Noto Sans Devanagari', 'Kailasa', 'Latha', sans-serif" },
                { id: 3, name: 'Lora',       stack: "'Lora', 'Noto Serif Tamil', 'Noto Serif Thai', 'Noto Serif Devanagari', serif" },
                { id: 4, name: 'Playfair Display', stack: "'Playfair Display', 'Noto Serif Tamil', 'Noto Serif Thai', 'Noto Serif Devanagari', Georgia, serif" },
                { id: 5, name: 'Merriweather', stack: "'Merriweather', 'Noto Serif Tamil', 'Noto Serif Thai', 'Noto Serif Devanagari', Georgia, serif" },
                { id: 6, name: 'Inter',      stack: "'Inter', 'Noto Sans Tamil', 'Noto Sans Thai', 'Noto Sans Devanagari', sans-serif" },
                { id: 7, name: 'Cormorant Garamond', stack: "'Cormorant Garamond', 'Noto Serif Tamil', 'Noto Serif Thai', 'Noto Serif Devanagari', serif" },
                { id: 3, name: 'Helvetica' },
                { id: 4, name: 'cursive' }, // Google Font
                { id: 5, name: 'fantasy' }, // Google Font
                { id: 6, name: 'ui-rounded' }, // Google Font
                { id: 7, name: 'Times New Roman' }, // Google Font
                { id: 8, name: 'fangsong'},
                { id: 9, name: 'Georgia'},
                { id: 10, name: 'Gill Sans'},
                // ... add more fonts
            ],
            locks: [
                {id:1, name: 'UnLocked'}
            ],
            share : [
                {id:1, name:'Copy URL'}
            ],
            selectedFont: null,
            wishes:[],
            backgroundImage: '',
            wbid: '',
            wbtitle: '',
            wbrecipient: '',
            allowEdit: false,
            showSidebar: false,
            isLocked: false,
            collapseBackgroundImage: true,
            collapseFont: true,
            collapseLock: true,
            activeTheme: '',

        }
    },
    computed: {
      // The 'For <name>' line is only useful when the title does not
      // already name them. Titles such as "Happy Birthday Keerthana Shri!"
      // otherwise print the name twice in the header -- which 203 of the boards
      // on record do today. Nothing is stored differently; this only decides
      // whether to draw the line.
      showRecipient() {
        return recipientAddsInfo(this.wbtitle, this.wbrecipient);
      },

    fontFamilyStyle() {
        // Resolve the saved/selected font name to its full fallback stack. Boards store a
        // bare name; legacy names (Helvetica, cursive...) still get a sane stack.
        const match = this.fonts.find(f => f.name === (this.selectedFont && this.selectedFont.name));
        const stack = match ? match.stack
          : ((this.selectedFont && this.selectedFont.name) || 'Sofia') + ", 'Noto Sans Tamil', 'Noto Sans Thai', 'Noto Sans Devanagari', sans-serif";
        return {
                fontFamily: stack,
        };
    },
    },



    methods: {
            // Never render an image larger than its native size. See Wishboard.vue.
            naturalSize(wish) {
                const d = wish && wish._naturalSize;
                if (!d) return {};
                return { width: d.w + 'px', height: d.h + 'px' };
            },
            onWishImageLoad(event, wish) {
                const img = event.target;
                if (!img || !img.naturalWidth) return;
                this.$set(wish, '_naturalSize', { w: img.naturalWidth, h: img.naturalHeight });
            },
                editMode(){
                    this.$router.push({
                        path: 'Wishboard',
                        query: {
                            wishboard_id: this.$route.query.wishboard_id,
                        }
                    });
                },
                isYouTubeUrl(url) {
                    // A stored wish_image_url is a YouTube link when it has a real video ID.
                    // The old domain-only test also matched playlists and channels, which
                    // then rendered as broken embeds.
                    return !!this.getYouTubeId(url);
                },
                // Same parser as Wishboard.vue: watch?v=, /live/, /shorts/, /embed/,
                // /v/, youtu.be, bare 11-char ids. Previously /live/ links were silently
                // unplayable in presentation mode because only embed/v=/youtu.be matched.
                youTubeIdFrom(url) {
                    if (!url) return '';
                    const raw = String(url).trim();
                    let m = raw.match(/(?:youtu\.be)\/([A-Za-z0-9_-]{11})(?:[?&#].*)?$/);
                    if (m) return m[1];
                    m = raw.match(/[?&]v=([A-Za-z0-9_-]{11})(?:[&#].*)?$/);
                    if (m) return m[1];
                    m = raw.match(/youtube\.com\/(?:live|shorts|embed|v|e)\/([A-Za-z0-9_-]{11})(?:[/?#].*)?$/);
                    if (m) return m[1];
                    if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return raw;
                    return '';
                },
                getYouTubeId(url) {
                    return this.youTubeIdFrom(url);
                },
                toggleYT(wish) { wish._ytPlaying = !wish._ytPlaying },
                initials(name) {
                    if (!name) return '?'
                    return name.trim().split(/\s+/).map(w => w[0].toUpperCase()).slice(0, 2).join('')
                },
                nameColor(name) {
                    if (!name) return '#aaa'
                    const colors = ['#e8a020','#3b82f6','#10b981','#8b5cf6','#ef4444','#f59e0b','#06b6d4','#ec4899','#84cc16','#f97316']
                    let hash = 0
                    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
                    return colors[Math.abs(hash) % colors.length]
                },
                formatWishDate(dateStr) {
                    if (!dateStr) return ''
                    const d = new Date(dateStr)
                    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
                },
                toggle_wish(wish){
                    wish.selected = !wish.selected;
                },
                delete_wish(wish) {
                    // Construct the URL for the delete message API endpoint
                    const url = `/mywishboard/api/wishboard/${this.wbid}/message/${wish.id}/delete/`;

                    // Make the API request to delete the message
                    axios.delete(url, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                    })
                    .then(response => {
                        // Handle successful deletion
                        console.log('Message deleted successfully:', response.data);

                        // Remove the wish from the wishes array
                        const index = this.wishes.indexOf(wish);
                        if (index !== -1) {
                            this.wishes.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        // Handle errors
                        console.error('Error deleting message:', error);
                    });
                },
                validate_tok() {
                    // console.log("validate token in wishboard vue");
                    var url = "/mywishboard/api/wishboard/user/token/verify/";
                    // var url = "http://localhost:8000/mywishboard/api/wishboard/user/token/verify/"; dev enable; prod disable
                    
                    axios.post(url, {}, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                    })
                    .then((response) => {
                        if (response.data && response.data.success === 'Token is available') {
                            console.log("Token is available");
                            // Handle the case where the token is available
                        } else if (response.data && response.data.error === 'Token expired') {
                            console.log("Token expired error");
                            this.$router.push("/login");
                            // Handle the case where the token is expired
                        } else if (response.data && response.data.error === 'User or Token error') {
                            console.log("User or Token error");
                            this.$router.push("/login");
                            // Handle the case where there is a user or token error
                        } else {
                            // Handle other cases or do nothing
                            
                        }
                    })
                    .catch((error) => {
                        this.$router.push("/login");
                        console.error("Error:", error);
                        // Handle other errors if needed
                    });

                },
            async handleVisibilityChange() {
                if (document.visibilityState === 'visible') {
                    // Page is visible, check authentication status and take appropriate action
                     this.validate_tok();
                }
            },


            copyURL() {
                const urlToCopy = window.location.href;
                this.copyToClipboard(urlToCopy);
                this.showToast("URL copied to clipboard! Share it with your friends");
                },
            copyToClipboard(text) {
                const textarea = document.createElement("textarea");
                textarea.value = text;
                textarea.style.position = "fixed";
                textarea.style.opacity = 0;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
                },
            showToast(message) {
                toast({
                    message: message,
                    type: 'is-success',
                    position: 'top-center',
                    duration: 3000,
                    dismissible: true,
                    pauseOnHover: true,
                });
            },
  

    async loadImage(image) {
        let thumbnail, original;
        thumbnail = image.thumbnailUrl; // static images
        original = (await image.original()).default; // dynamic images
        return { thumbnail, original };
    },
        toggleThemes(theme){
            if (this.activeTheme === theme) {
                this.activeTheme = ''; // Collapse the clicked theme if it's already active
            } else {
                this.activeTheme = theme; // Otherwise, set it as the active theme
            }

            this.collapseBackgroundImage = this.activeTheme !== 'background';
            this.collapseFont = this.activeTheme !== 'font';
            this.collapseLock = this.activeTheme !== 'lock';
            },

        shuffleImages() {
            // Fisher-Yates shuffle algorithm
            for (let i = this.images.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this.images[i], this.images[j]] = [this.images[j], this.images[i]];
            }
        },

        call_lock(status){
            this.isLocked = !this.isLocked
            axios.post('/mywishboard/api/wishboard/usersettings/' + this.wbid + '/lock/',
              {
                  'user': this.$store.getters.getUser,
                  'is_locked': this.isLocked,
              },
              {
                    headers: { 
                        'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                    }
              })
            
        },
          toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
          selectFont(font) {
            this.selectedFont = font;
              axios.post('/mywishboard/api/wishboard/usersettings/' + this.wbid + '/',
              {
                  'font_name': this.selectedFont.name,
              },
              {
                    headers: { 
                        'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                    }
              })
        },

        call_sidebar: function (message, event){
            this.showSidebar = !this.showSidebar;
            this.shuffleImages();
        },

        async change_bg(message, image) {
            const { thumbnail, original } = await this.loadImage(image);
            this.backgroundImage = `url(${original})`;
    
            //   this.backgroundImage = 'url(https://cdn.pixabay.com/photo/2017/10/25/08/25/cupcakes-2887270_1280.jpg)';
            
            axios.post('/mywishboard/api/wishboard/usersettings/' + this.wbid + '/',
            {
                'font_name': this.selectedFont.name,
                ...(this.backgroundImage && { 'background_url': this.backgroundImage }),
            },
            {
                headers: { 
                    'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                }
            })
          },


        fetch(wishboard_id) {
            return axios.get('/mywishboard/api/wishlist/?wishboard_id=' + wishboard_id)
            .then((response) => {
                this.wishes = response.data;
                return this.wishes;
            })
            .catch(err => console.log(err));
        }
        
    },
        
    mounted() {

                var scalar = 15;
                var pineapple = confetti.shapeFromText({ text: 'B A B Y', scalar });

                    // Show confetti only on the first page load
                localStorage.setItem('hasShownConfetti', false);
                // if (!localStorage.getItem('hasShownConfetti')) {
                // Left side confetti burst
                confetti({
                    particleCount: 300, // Number of confetti pieces
                    angle: 120,   // Spread of confetti (60 degrees)
                    spread: 360,   // Density of confetti (30 radius)
                    shapes: ['star', 'circle', 'square'], // Confetti shapes
                    colors: ['#f44336', '#e91e63', '#9c27b0'], // Confetti colors
                     scale: 0.3,
                     ticks: 500,
                    gravity: 0.2, 
                      origin: {
                                    x: 0.1, // Left side
                                    y: Math.random() - 0.2
                                }
                });
            
                // Right side confetti burst  
                setTimeout(() => {
                    confetti({
                        particleCount: 300, // Number of confetti pieces
                        angle: 60,   // Spread of confetti (60 degrees)
                        spread: 360,   // Density of confetti (30 radius)
                        shapes: ['star', 'circle', 'square'], // Confetti shapes
                        colors: ['#f44336', '#e91e63', '#9c27b0'], // Confetti colors
                         scale: 0.3,
                         ticks: 500,
                        gravity: 0.2, 
                          origin: {
                                        x: 0.9, // Right side
                                        y: Math.random() - 0.2
                                    }
                    });
                }, 150);

                localStorage.setItem('hasShownConfetti', false); // Store flag to prevent repetition
                // }

            
            this.emitter.on('validateTokEvent', this.validate_tok);
    
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
            document.addEventListener('click', this.handleOutsideClick);

            this.emitter.emit('showlogout', 'true');
            this.emitter.emit('showWishboardCreate', 'true');
            this.emitter.emit('showWishboardList', 'true');

            // Get a random index within the range of the images array length
            // const randomIndex = Math.floor(Math.random() * this.images.length);
            // this.backgroundImage = this.images[randomIndex];

            var wbid = this.$store.state.wishboard_id_vue;
            wbid = this.$route.query.wishboard_id;
            this.wbid = wbid;
            this.fetch(wbid).then(() => {
                var listorg = this.wishes;
                this.wishes = listorg.map((review) => {
                    return {
                        id: review.id,
                        wisher_name: review.wisher_name,
                        wisher_message: review.wisher_message,
                        wish_image_url: review.wish_image_url,
                        wish_message_date: review.wish_message_date,
                        _ytPlaying: false,
                        selected: false,
                    };
                });
            });


                axios.post('/mywishboard/api/wishboard/metadetails/get/',
                    {
                        'wbid': wbid
                    },
                    {
                        headers: { 
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                    })
                    .then((response) => {
                        if(response.status >= 200){
                            this.wbtitle = response.data["wb_title"]
                            this.wbrecipient = response.data["wb_recipient"]
                        }
                    })




                    axios.get('/mywishboard/api/wishboard/usersettings/' + wbid +'/get/',
                    {
                        headers: { 
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                
                    })
                    .then((response) => {
                        if(response.status == 200){
                            this.backgroundImage = response.data["wishboard_background_url"];
                            const retrievedFontName = response.data["wishboard_font_name"];
                            this.selectedFont  = {name : retrievedFontName}
                        }else{
                            this.backgroundImage = 'url(https://cdn.pixabay.com/photo/2017/10/25/08/25/cupcakes-2887270_1280.jpg)';
                        }
                    });                


                    axios.post('/mywishboard/api/wishboard/usersettings/' + wbid +'/validate/',
                    {
                        'user':this.$store.getters.getUser
                    },
                    {
                        headers: { 
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                
                    })
                    .then((response) => {
                        if(response.status == 200){
                            if(response.data["wishboard_created_by_logged_user"] == true)
                                this.allowEdit = true;
                            else
                                this.allowEdit = false;
                        }else{
                            this.allowEdit = false;
                        }
                    });                

                    // check for locked board status

                    axios.get('/mywishboard/api/wishboard/usersettings/' + wbid +'/lockstatus/',
                    {
                        'user':this.$store.getters.getUser
                    },
                    {
                        headers: { 
                            'Authorization': 'Bearer ' + this.$store.getters.getGToken,
                        }
                    })
                    .then((response) => {
                        if(response.status == 200){
                            if(response.data["is_locked"] == true)
                                this.isLocked = true;
                            else
                                this.isLocked = false;
                        }
                    });                
 
            }
}
</script>

<style>
@import "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Raleway:wght@400;600&family=Sofia&family=Lora:ital,wght@0,400;0,600;1,400&family=Playfair+Display:wght@400;600;700&family=Merriweather:wght@400;700&family=Cormorant+Garamond:wght@400;600;700&family=Noto+Sans+Tamil:wght@400;600&family=Noto+Serif+Tamil:wght@400;600&family=Noto+Sans+Thai:wght@400;600&family=Noto+Serif+Thai:wght@400;600&family=Noto+Sans+Devanagari:wght@400;600&family=Noto+Serif+Devanagari:wght@400;600&display=swap";
</style>

<style scoped>

/* Override .relative from styles_from_django.css */
.wb-wrap {
  margin: 0;
  padding: 0;
  background: transparent;
}

.wb-sticky-header {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 50;
  background: rgba(255,255,255,0.88);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(0,0,0,0.07);
  padding: 10px 20px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
}

.wb-header-titles {
  grid-column: 2;
  text-align: center;
}

.wb-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: #0a0a0a;
  font-family: 'Inter', -apple-system, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wb-recipient {
  font-size: 0.85rem;
  color: #777;
  font-family: 'Inter', -apple-system, sans-serif;
}

.wb-actions {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.wb-action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border-radius: 20px;
  border: 1px solid rgba(0,0,0,0.12);
  background: rgba(255,255,255,0.9);
  color: #333;
  font-size: 0.78rem;
  font-weight: 700;
  font-family: 'Inter', -apple-system, sans-serif;
  cursor: pointer;
  transition: all 0.15s;
}
.wb-action-btn:hover { background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.wb-action-btn i { font-size: 1rem; }

#bg.cards {
    display: flex !important; /* row-major: reads left-to-right, wraps per row.
                                 Pre-redesign this was flex-wrap; the redesign
                                 switched to column-count, which fills each column
                                 top-to-bottom and so scrambled chronological order. */
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 28px; /* matches the previous column-gap so spacing is unchanged */
    padding: 175px 44px 80px !important;
    min-height: 100vh;
    background-size: auto;
    background-position: center;
    background-repeat: repeat;
    box-sizing: border-box;
  }

.wishcard {
  break-inside: avoid !important; /* inert under flex, keeps a card from splitting */
  width: auto !important;
  /* Row width: three across with the container's 28px gap, minus the card's own
     horizontal margin. Without an explicit basis here, `width: 100%` (still set
     for the column-count layout this replaced) makes every card a full-width row.
     calc uses percentage-of-container widths, so the margin is subtracted in
     proportion rather than in absolute pixels. */
  /* Basis for THREE across: subtract the two inter-card gaps the browser inserts
     between a 3-up row, then divide. `gap` is handled separately by flex, so it
     must not also be subtracted as card margin -- doing both made each card
     ~9px too wide and only two fitted per row.
     No `flex-basis: unset` either: it was inherited from the column-count
     layout where width:100% did the sizing. Under flex it silently discards the
     basis the `flex` shorthand just set (unset -> initial -> auto), putting every
     card on its own row. */
  /* The legacy stylesheet (styles_from_django.css) gives .wishcard
     `margin: 12px`. Under column-count that was invisible -- the column
     absorbed it -- but under flex-wrap it adds 24px of margin per card on top
     of the container's 28px gap, so three cards needed 1440px+ inside a
     1352px row and only two fit. Margin and gap were double-counting the same
     spacing. Drop the horizontal margin and let `gap` own it; the vertical
     margin-bottom is kept for row rhythm. */
  margin-left: 0 !important;
  margin-right: 0 !important;
  flex: 0 0 calc((100% - 56px) / 3) !important;
  max-width: 100% !important;
  max-height: unset !important;
  box-sizing: border-box;
}

.wishcard:hover { transform: translateY(-3px); box-shadow: 0 10px 32px rgba(0,0,0,0.13); }

/* Media sits flush to the card edge, so its radius must match the card's INNER
   clip radius (border-radius minus border width). At 16px vs a 15px inner clip the
   corners overshoot and get sliced — this is the "clipped at the top" effect.

   The image uses height:auto + max-height rather than a fixed box, so the
   wrapper grows with the image and nothing is cropped to fit. */
.wish-media { width: 100%; overflow: hidden; /* Must not exceed the card's inner clip radius (16px - 1px border); 15px is exact. */ border-radius: 15px 15px 0 0; }
/* Boards accept any image, so bound tall media by viewport height rather than a fixed px cap that would slice portraits. */
.wish-img {
  /* Never upscale — see Wishboard.vue for why. Small Giphy GIFs were being magnified.
     Inline width/height from naturalSize() keeps images at 1:1 or smaller. */
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  margin: 0 auto;
  background: transparent;
  display: block;
}

.wish-yt { position: relative; width: 100%; cursor: pointer; background: #111; }
/* hqdefault.jpg is 480x360 (4:3). The old fixed `height: 190px` + cover forced it
   into a 430x190 landscape box and cropped ~43% off the top and bottom. Render at the
   natural ratio and cap it instead. */
.wish-yt-thumb { width: 100%; height: auto; max-height: 480px; object-fit: cover; display: block; opacity: 0.9; }
.wish-yt-play { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.18); }
.wish-yt-play i { font-size: 4rem; color: #fff; filter: drop-shadow(0 2px 10px rgba(0,0,0,0.55)); }
/* Matches .wish-yt-thumb's natural 4:3 so the card doesn't shrink on click — see
   Wishboard.vue. Was a hardcoded height: 220px. */
.wish-yt-frame { width: 100%; aspect-ratio: 4 / 3; max-height: 480px; display: block; border: none; background: #000; }

.wish-body { padding: 16px 18px 10px; }
/* Fluid type — mirrors Wishboard.vue so both views scale together. */
.wish-message { font-size: clamp(0.95rem, 0.88rem + 0.35vw, 1.15rem); line-height: 1.75; color: #1a1a1a; margin: 0; white-space: pre-line; word-break: break-word; font-family: inherit; }

.wish-footer { display: flex; align-items: center; gap: 10px; padding: 10px 18px 16px; border-top: 1px solid rgba(0,0,0,0.05); font-family: inherit; }
.wish-avatar { width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; font-size: 0.68rem; font-weight: 800; color: #fff; }
.wish-meta { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.wish-name { font-size: 0.85rem; font-weight: 700; color: #111; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wish-date { font-size: 0.72rem; color: #bbb; }

@media (max-width: 1200px) and (min-width: 601px) {
      #bg.cards { gap: 28px; padding: 160px 28px 60px !important; }
      .wishcard { flex: 0 0 calc((100% - 28px) / 2) !important; }
    }
@media (max-width: 600px) {
      #bg.cards { gap: 0; padding: 150px 14px 40px !important; }
      .wishcard { flex: 0 0 100% !important; }

      .wb-action-btn span { display: none; }
    }
</style>
